import { createContext } from 'react';

export const SideDetailsAnimateContext = createContext(null);